import { NgModule } from '@angular/core';
import { CBScrollbarDirective } from '@core/directives/scrollbar/scrollbar.directive';

@NgModule({
    declarations: [
        CBScrollbarDirective
    ],
    exports     : [
        CBScrollbarDirective
    ]
})
export class CBScrollbarModule
{
}
